import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetMultipleSupportEnabled = () => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['is-multiple-support-enabled'],
        queryFn: async () => await apiClient.get(`countertop-university/is-multiple-support-enabled`) as boolean
    });

    return {
        data: data ?? {} as boolean,
        isLoading,
        refetch
    };
};
